import {
  BaseMultiColumnAutoComplete,
  BaseMultiColumnAutoCompleteProps,
} from '@modules/common/components/MultiColumnAutoComplete/BaseMultiColumnAutoComplete';
import { MultiColumnAutoCompleteStoreProvider } from './hooks/useMultiColumnAutoCompleteStore/MultiColumnAutoCompleteStoreProvider';

export function MultiColumnAutoComplete<T extends { id: string }>(
  props: BaseMultiColumnAutoCompleteProps<T>,
) {
  return (
    <MultiColumnAutoCompleteStoreProvider>
      <BaseMultiColumnAutoComplete {...props} />
    </MultiColumnAutoCompleteStoreProvider>
  );
}
